package one.healthium.reminders.domain

import kotlinx.datetime.DatePeriod
import one.primehealth.app.DeepLink
import kotlin.time.Duration

data class ReminderModel(
    val notifications: List<ReminderNotificationModel>,
    val deepLink: DeepLink?,
    val type: ReminderType,
)

sealed interface ReminderType {
    val time: Time
    val timeWindow: Duration?

    data class Periodic(
        override val time: Time,
        override val timeWindow: Duration?,
        val period: DatePeriod,
    ) : ReminderType

    data class OneTime(
        override val time: Time,
        override val timeWindow: Duration?,
    ) : ReminderType
}

data class Time(
    val hour: Int,
    val minute: Int,
)